import mensagens from '@/util/mensagens'
import { BToast, BSpinner } from 'bootstrap-vue'
import constants from '@/util/constants'
import util from '@/util'
import { mapState, mapActions } from 'vuex'
import { infraMixin } from '@/modules/infra/mixins'
import { obterImagem } from '@/util/imagem'

export default {
  name: 'PrimeiroAcesso',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner
  },
  mixins: [infraMixin],

  computed: {
    ...mapState('auth', ['perfilUsuario']),
    obterLogo () {
      return obterImagem('logo-office300.png')
    }
  },

  data: () => {
    return {
      formulario: {
        f_original_password: null,
        f_new_password: null,
        f_confirm_password: null
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      },
      flagsDeControle: {
        manipulandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },

  mounted () {
    this.limparListaErros()
  },

  methods: {
    ...mapActions('auth', ['ActionSignOut']),

    async alterarSenha () {
      this.limparListaErros()
      try {
        this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)

        const resposta = await this.axios.post('/usuario/alterar/senha-primeiro-acesso', this.formulario)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros

        await this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
        this.definirFlagManipulandoDados(false, '')
      }
    },

    async tratarAposSalvarRegistro () {
      if (this.retorno.sucesso) {
        const listaPerfisAcessoDiretoJuridico = this.obterListaPerfisAcessoDiretoJuridico()
        const perfilPodeAcessarDiretoJuridico = (listaPerfisAcessoDiretoJuridico.indexOf(this.perfilUsuario) !== -1)
        if (perfilPodeAcessarDiretoJuridico) {
          await this.redirecionarParaSistemaExterno(constants.urlSistemaExterno.juridico, false)
          this.ActionSignOut()
        } else {
          this.redirecionarParaManager('inicio', () => {
            util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
          })
        }
      } else {
        const mensagemRetorno = this.retorno.mensagem
        const flagUsuarioAtivo = this.retorno.listaDeErros.flagUsuarioAtivo
        if (!util.valorVazio(flagUsuarioAtivo)) {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno + '. ' + flagUsuarioAtivo)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno)
        }
        this.definirFlagManipulandoDados(false, '')
      }
    },

    limparListaErros () {
      this.retorno.listaDeErros = {}
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    eventoLoginTeclaEnter (evento) {
      if (evento.keyCode === constants.teclado.enter) {
        this.alterarSenha()
      }
    }
  }
}
